// U2: 只在浏览器内保留匿名性能基线，不上传用户数据。
// 现场可从 window.__quantWebVitals 读取 FCP/LCP/CLS/INP 与导航耗时。
export function startWebVitalsBaseline(target = window) {
  if (!target?.performance) return null;

  const metrics = {
    schema: 'quant-web-vitals-v1',
    fcp_ms: null,
    lcp_ms: null,
    cls: 0,
    inp_ms: null,
    ttfb_ms: null,
    dom_content_loaded_ms: null,
    load_ms: null,
  };
  target.__quantWebVitals = metrics;

  const meta = target.document?.createElement?.('meta');
  if (meta && target.document?.head) {
    meta.name = 'quant-web-vitals';
    target.document.head.appendChild(meta);
  }
  const publish = () => {
    if (meta) meta.content = JSON.stringify(metrics);
  };
  publish();

  const observe = (type, callback, options = {}) => {
    if (!target.PerformanceObserver?.supportedEntryTypes?.includes(type)) return;
    try {
      const observer = new target.PerformanceObserver((list) => callback(list.getEntries()));
      observer.observe({ type, buffered: true, ...options });
    } catch { /* 老浏览器不影响产品运行 */ }
  };

  observe('paint', (entries) => {
    const fcp = entries.find((entry) => entry.name === 'first-contentful-paint');
    if (fcp) metrics.fcp_ms = Math.round(fcp.startTime);
    publish();
  });
  observe('largest-contentful-paint', (entries) => {
    const latest = entries[entries.length - 1];
    if (latest) metrics.lcp_ms = Math.round(latest.startTime);
    publish();
  });
  observe('layout-shift', (entries) => {
    metrics.cls = Number((metrics.cls + entries
      .filter((entry) => !entry.hadRecentInput)
      .reduce((total, entry) => total + entry.value, 0)).toFixed(4));
    publish();
  });
  observe('event', (entries) => {
    const longest = Math.max(0, ...entries.map((entry) => entry.duration || 0));
    if (longest) metrics.inp_ms = Math.round(Math.max(metrics.inp_ms || 0, longest));
    publish();
  }, { durationThreshold: 40 });

  const readNavigation = () => {
    const navigation = target.performance.getEntriesByType('navigation')[0];
    if (!navigation) return;
    metrics.ttfb_ms = Math.round(navigation.responseStart);
    metrics.dom_content_loaded_ms = Math.round(navigation.domContentLoadedEventEnd);
    metrics.load_ms = Math.round(navigation.loadEventEnd || target.performance.now());
    publish();
  };
  if (target.document?.readyState === 'complete') readNavigation();
  else target.addEventListener?.('load', readNavigation, { once: true });

  return metrics;
}
